import { render, staticRenderFns } from "./recap.vue?vue&type=template&id=ed662fea&scoped=true&"
import script from "./recap.vue?vue&type=script&lang=js&"
export * from "./recap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed662fea",
  null
  
)

export default component.exports